<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_basics">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="prod_id" [ttModel]="menu.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="menu.prod_name" ttReadonly></tt-input>
        <tt-image *ngIf="!!menu.url_picture" ttLabel="picture" [ttSrc]="menu.url_picture"></tt-image>
        <tt-textarea *ngIf="menu.show_custom_key_information1 === '1'" ttLabel="custom_key_information1" [ttModel]="menu.custom_key_information1" ttReadonly></tt-textarea>
        <tt-textarea *ngIf="menu.show_custom_key_information2 === '1'" ttLabel="custom_key_information2" [ttModel]="menu.custom_key_information2" ttReadonly></tt-textarea>
        <tt-textarea *ngIf="menu.show_custom_key_information3 === '1'" ttLabel="custom_key_information3" [ttModel]="menu.custom_key_information3" ttReadonly></tt-textarea>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'productview_edit_product'" [ttGoto]="'product'" [ttGotoParms]="{ prod_id: menu.prod_id }"></tt-button-goto>
        <tt-button ttText="product_show_stock" (ttClick)="goToFunc('stock')" ttIcon="fas fa-chevron-right" ttType="primary"></tt-button>
        <tt-button-settings *ngIf="menu.show_setting === '1'"></tt-button-settings>
    </ng-container>
</ng-template>
